<template>
    <VisSingleContainer :height="42" :width="42" :style="containerStyle">
        <VisDonut
            :value="(d: DataRecord) => d.value"
            :data="data"
            :color="donutColor"
            :show-empty-segments="true"
            :pad-angle="0.01"
            :arc-width="10"
        />
    </VisSingleContainer>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { VisSingleContainer, VisDonut } from "@unovis/vue";

interface DataRecord {
    key: string;
    value: number;
}

const props = defineProps<{
    data: DataRecord[];
}>();

const isEmpty = computed(() => props.data.every((d) => (d.value ?? 0) === 0));

const containerStyle = computed(() =>
    isEmpty.value ? { "--vis-donut-background-color": "#9FA6B2" } : undefined,
);

const donutColor = (d: DataRecord) => {
    if (d.key === "compliant") return "#22c55e";
    if (d.key === "non-compliant") return "#ef4444";
    return "#9FA6B2";
};
</script>
